/// <amd-module name="Artifacts/Npm/commands/UpstreamOverride" />

import { NpmActions } from "Artifacts/Npm/redux";
import { getUpstreamOverrideCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createUpstreamOverrideCommand = getUpstreamOverrideCommandCreator(
  NpmActions.setUpstreamOverride,
);
